var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
jQuery(document).on('ready js_event_wpv_parametric_search_results_updated js_event_wpv_parametric_search_form_updated', function (event, data) {
    if (event.type === 'ready' || event.type === 'js_event_wpv_parametric_search_results_updated') {
        jQuery('.wm-categories__filterCategoriesList label').click(function () {
            jQuery('.wpv-reset-trigger.-active').removeClass('-active');
            jQuery('.wm-categories__filterCategoriesList label.-active').removeClass('-active');
            jQuery(this).addClass('-active');
            var catHeading = jQuery(this).text();
            var bloglistHeader = jQuery('.wm-blogPostListHeader');
            var vidlistHeader = jQuery('.wm-videoPostListHeader');
            if (bloglistHeader.length > 0) {
                bloglistHeader.text(catHeading);
            }
            else if (vidlistHeader.length > 0) {
                vidlistHeader.text(catHeading);
            }
            jQuery('.wm-categories__filterCategoriesMenu.-open').removeClass('-open');
            let activeText = jQuery(this).text();
            let selectedOption = jQuery('.wm-categories__filterCategoriesMenuSelectedOption span');
            let newText = selectedOption.text().replace(selectedOption.text(), activeText);
            selectedOption.text(newText);
        });
        jQuery('.wpv-reset-trigger').click(function () {
            jQuery('.wm-categories__filterCategoriesList label.-active').removeClass('-active');
            jQuery('.wm-categories__filterCategoriesMenu.-open').removeClass('-open');
            let activeText = jQuery(this).text();
            let selectedOption = jQuery('.wm-categories__filterCategoriesMenuSelectedOption span');
            let newText = selectedOption.text().replace(selectedOption.text(), activeText);
            selectedOption.text(newText);
        });
    }
    jQuery('.wm-categories__filterCategoriesMenuSelectedOption').click(function () {
        jQuery('.wm-categories__filterCategoriesMenu').addClass('-open');
    });
});
jQuery(document).on('ready', function () {
    var currentBlogCat = getUrlParameter('wpv-category');
    console.log(currentBlogCat);
    if (currentBlogCat != false) {
        var labelTag = "post_category-" + currentBlogCat;
        var labelTarget = jQuery('label[for="' + labelTag + '"]');
        labelTarget.addClass('-active');
        var catHeading = jQuery(labelTarget).text();
        jQuery('.wm-blogPostListHeader').text(catHeading);
    }
    var currentVidCat = getUrlParameter('wpv-category');
    if (currentVidCat != false) {
        var labelTag = "post_category-" + currentVidCat;
        var labelTarget = jQuery('label[for="' + labelTag + '"]');
        labelTarget.addClass('-active');
        var catHeading = jQuery(labelTarget).text();
        jQuery('.wm-videoPostListHeader').text(catHeading);
    }
});
